"use client";

import { useState } from "react";
import { useRouter } from "@/i18n/navigation";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type ContactSuccessDialogProps = {
	openByDefault: boolean;
	isPt: boolean;
};

export function ContactSuccessDialog({
	openByDefault,
	isPt,
}: ContactSuccessDialogProps) {
	const router = useRouter();
	const [open, setOpen] = useState(openByDefault);

	function handleOpenChange(nextOpen: boolean) {
		setOpen(nextOpen);
		if (!nextOpen) {
			router.replace("/");
		}
	}

	return (
		<AlertDialog open={open} onOpenChange={handleOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{isPt ? "Mensagem enviada!" : "Message sent!"}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{isPt
							? "Sua mensagem foi enviada. Responderemos em breve."
							: "Your message has been sent. We will reply soon."}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogAction>{isPt ? "Entendi" : "Got it"}</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
